/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmExtractExtractWithSchema } from "../../funcs/llmExtractExtractWithSchema.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ExtractWithSchemaRequest$inboundSchema,
};

export const tool$llmExtractExtractWithSchema: ToolDefinition<typeof args> = {
  name: "llm-extract-extract-with-schema",
  description: `Extract data using saved schema template

Extracts structured data from files using a previously saved extraction schema template.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmExtractExtractWithSchema(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
